import { render } from "./DynamicFieldset.vue?vue&type=template&id=2540ef42&ts=true"
import script from "./DynamicFieldset.vue?vue&type=script&lang=ts"
export * from "./DynamicFieldset.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicFieldset.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2540ef42"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2540ef42', __exports__)) {
    api.reload('2540ef42', __exports__)
  }
  
  module.hot.accept("./DynamicFieldset.vue?vue&type=template&id=2540ef42&ts=true", () => {
    api.rerender('2540ef42', render)
  })

}


export default __exports__